export const hostname = (_config, _data, globalConfig) => {
  return {
    hostname: globalConfig.hostname
  };
};